import { EventsManagerRecordModel } from '@vp/manager/events/core/model/EventsManagerRecordModel';

export class SubmitEventsResultDto {
  constructor(
    readonly createdEvents: EventsManagerRecordModel[],
    readonly updatedEvents: EventsManagerRecordModel[],
  ) {}
}
